import type { TFunction } from 'i18next';

import { MFA_FACTOR, type MfaFactor } from '@repo/common';

import { consumeReplaceSmsIntent } from './mfa-method-picker-utils';
import { MfaAddAnotherMethodDialog } from './mfa-sms-manage';

export function MfaSmsAddMethodDialog({
  enrolled,
  isMobile,
  onAddEnrolledFactor,
  onCancel,
  onChooseMethod,
  onOpenPasskeySetup,
  onRemoveSms,
  t,
}: {
  enrolled: readonly string[];
  isMobile: boolean;
  onAddEnrolledFactor: (method: MfaFactor) => void;
  onCancel: () => void;
  onChooseMethod: (method: MfaFactor) => void;
  onOpenPasskeySetup: () => void;
  onRemoveSms: () => void;
  t: TFunction<'common'>;
}) {
  return (
    <MfaAddAnotherMethodDialog
      isMobile={isMobile}
      onBack={() => {
        consumeReplaceSmsIntent();
        onRemoveSms();
      }}
      onCancel={() => {
        consumeReplaceSmsIntent();
        onCancel();
      }}
      onChooseEmail={() => {
        if (enrolled.length > 0) {
          onAddEnrolledFactor(MFA_FACTOR.Email);
          return;
        }
        onChooseMethod(MFA_FACTOR.Email);
      }}
      onChoosePasskey={onOpenPasskeySetup}
      onChooseTotp={() => {
        if (enrolled.length > 0 && !enrolled.includes(MFA_FACTOR.Totp)) {
          onAddEnrolledFactor(MFA_FACTOR.Totp);
          return;
        }
        onChooseMethod(MFA_FACTOR.Totp);
      }}
      t={t}
    />
  );
}
